// @flow
export type USER_ROLE = 'user' | 'admin' | 'organization_manager' | 'institution_manager';

export const ADMINS = ['admin', 'organization_manager', 'institution_manager'];
